import { head } from 'lodash';
import { conditionsCompiler } from 'pages/Communications/ScenarioSetupPage/actionCompilers/utils/conditionsCompiler';

// {} => [{}] => compiler settings => head() => {}
export const compilerSegmentCondition = settingsCondition => head(conditionsCompiler([settingsCondition]));
